<template>
  <div class="install">
    <h4 v-if="steps[step]">
      {{ partner.name }} -
      {{ step | setText(steps[step].title) }}
    </h4>
    <div v-if="done">
      <h4>{{ "order_done" | setText("Заказ выполнен") }}</h4>
    </div>
    <template v-for="(value, stepKey) in steps">
      <template v-if="step == stepKey">
        <component
          :createTransaction="createTransaction"
          :updateOrder="updateOrder"
          :transaction="transaction"
          :order="order"
          :partner="partner"
          :partner_id="partner_id"
          :is="stepKey"
          @setStep="setStep"
          :key="stepKey"
          v-model="body"
        />
      </template>
    </template>

    <div v-if="step === 'need-cancel'">
      <h4>
        {{
          "need-cancel-order"
            | setText(
              "Заказ нельзя завершить. Необходимо отменить и начать сначала"
            )
        }}
      </h4>
    </div>

    <cancel-loan
      v-if="transaction && !done"
      :createTransaction="createTransaction"
      :updateOrder="updateOrder"
      :transaction="transaction"
      :order="order"
      :partner="partner"
      :partner_id="partner_id"
      @setStep="setStep"
    />
  </div>
</template>
<script>
export default {
  name: "tbc",
  props: [
    "order",
    "updateOrder",
    "partner_id",
    "createTransaction",
    "transaction",
    "partner",
  ],
  methods: {
    setStep(step = null) {
      if (!step) {
        this.$emit("close", true);
      } else {
        this.step = step;
      }
    },
  },
  watch: {},
  components: {
    "pre-scoring": () => import("./PreScoring"),
    "confirm-pre-scoring": () => import("./ConfirmPreScoring"),
    "get-offers-limit": () => import("./GetOffersLimit"),
    "send-data": () => import("./SendData"),
    "send-data-send-sms": () => import("./SendDataSendSms"),
    "customer-data": () => import("./CustomerData"),
    "confirm-card-otp": () => import("./ConfirmCardOtp"),
    "get-offers-offer": () => import("./GetOffersOffer"),
    "accept-offer": () => import("./AcceptOffer"),
    "confirm-sign-contract-otp": () => import("./ConfirmSignContractOtp"),
    "send-signed-contract": () => import("./SendSignedContract"),
    "cancel-loan": () => import("./CancelLoan"),

    "tbc-accept": () => import("./TbcAccept"),
    "tbc-add-card": () => import("./TbcAddCard"),
    "tbc-create-application": () => import("./TbcCreateApplication"),
    "tbc-disburse-installment": () => import("./TbcDisburseInstallment"),
    "tbc-release-loan": () => import("./TbcReleaseLoan"),
    "tbc-get-otp": () => import("./TbcGetOtp"),
  },
  created() {
    try {
      if (
        this.transaction &&
        this.transaction.step &&
        this.steps[this.transaction.step]
      ) {
        this.step = this.transaction.step;
      } else if (this.transaction.step === "need-cancel") {
        this.step = this.transaction.step;
      }
    } catch (error) {}
  },
  computed: {
    done() {
      return (
        this.transaction &&
        this.transaction.system_confirmed &&
        this.transaction.client_confirmed &&
        this.transaction.status > -1
      );
    },
  },
  data() {
    return {
      body: null,
      step: "pre-scoring",
      steps: {
        "pre-scoring": {
          title: "Создание заказа",
        },
        "confirm-pre-scoring": {
          title: "Подтвержден смс",
        },
        "get-offers-limit": {
          title: "Предложение по лимиту и срок",
        },
        "send-data": {
          title: "Отправить фотографию",
        },
        "customer-data": {
          title: "Проверка товаров",
        },
        "confirm-card-otp": {
          title: "Подтверждение кода смс UZCARD",
        },
        "get-offers-offer": {
          title: "Выбор предложения по рассрочке",
        },
        "accept-offer": {
          title: "Подтвреждение заказа",
        },
        "confirm-sign-contract-otp": {
          title: "Подтвреждение заказа кодом из СМС",
        },
        "send-signed-contract": {
          title: "Загрузка подписанного договора",
        },
        "send-data-send-sms": {
          title: "Подтверждение СМС",
        },
        "tbc-accept": {
          title: "Подтвердить ",
        },
        "tbc-add-card": {
          title: "Добавить карту",
        },
        "tbc-create-application": {
          title: "Создать заявку",
        },
        "tbc-disburse-installment": {
          title: "Подтвердить",
        },
        "tbc-release-loan": {
          title: "Осуществление сделки",
        },
        "tbc-get-otp": {
          title: "Подтверждение сделки",
        },

      },
    };
  },
};
</script>

